<template>
  <div class="columns is-centered is-mobile">
    <div class="column login-form-wrapper">
      <div class="login-form">
        <h1 class="title">Confirm email change</h1>
        <h3 class="title">{{ oldEmail }} -> {{ newEmail }}</h3>
        <div class="login-form__item">
          <b-button class="confirm-button"
                    type="is-success" @click.prevent.stop="submit">CONFIRM</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { SnackbarProgrammatic as Snackbar } from 'buefy';
import { LOGOUT_AND_CLEAR_STATE } from '@/store/actions';
import { SET_SPLASH, SET_PRELOADER } from '../store/mutations';
import { RESTORE_LINK_DECRYPT } from '../store/modules/auth/actions';
import { CONFIRM_CHANGE_EMAIL } from '../store/modules/user/actions';

export default {
  name: 'ConfirmChangeEmail',

  data() {
    return {
      enc: null,
      oldEmail: '',
      newEmail: '',
    };
  },

  beforeMount() {
    const enc = this.lodash.get(this.$route, 'query.m');

    this.preloader(true);
    this.linkDecrypt({ enc }).then((response) => {
      this.enc = enc;
      this.oldEmail = response.email;
      this.newEmail = response.newEmail;
    }).catch(() => {
      Snackbar.open({
        type: 'is-danger',
        message: 'Link is invalid',
        position: 'is-top',
        indefinite: true,
        actionText: ' ',
      });
    }).finally(() => this.preloader(false));
  },

  methods: {
    ...mapMutations({
      splash: SET_SPLASH,
      preloader: SET_PRELOADER,
    }),
    ...mapActions('auth2', { linkDecrypt: RESTORE_LINK_DECRYPT }),
    ...mapActions('user', { confirmEmail: CONFIRM_CHANGE_EMAIL }),
    ...mapActions({ logoutAndClear: LOGOUT_AND_CLEAR_STATE }),
    logout() {
      this.$store.commit(SET_SPLASH, true);
      this.splash(true);
      this.logoutAndClear().then(() => {
        this.$router.replace('/login').then(() => {
          this.splash(false);
        });
      });
    },
    submit() {
      this.preloader(true);
      this.confirmEmail({ enc: this.enc }).then(() => {
        this.$buefy.toast.open({
          message: 'Thank you! <br /> <small>Your email has been successfully changed</small>',
          type: 'is-success',
          duration: 5000,
        });
        this.logout();
      }).catch((error) => {
        this.$buefy.toast.open({
          message: this.lodash.get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com'),
          type: 'is-danger',
          duration: 5000,
        });
      })
        .finally(() => this.preloader(false));
    },
  },

};
</script>

<style scoped lang="stylus">
@require "../assets/style/modern/variables.styl";
.login-form-wrapper
  display flex
  justify-content center
  padding-right 0
  .login-form
    @media (max-width: $breakpoints.md)
      padding 30px 16px
    max-width 750px
    margin 20px 20px 0 20px
    width 100%;
    background white
    border-radius 6px
    padding 30px 55px
    box-shadow 0 18px 32px rgba(156, 173, 173, 0.2);
    color #293033
    &__item
      text-align center
      .confirm-button
        width 100%
        max-width 240px
        min-width 120px
        height 48px
        font-size 20px
        @media (max-width: $breakpoints.md)
          font-size 16px
          max-width unset
          min-width unset

</style>
